import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Initialize with actual value to prevent undefined state
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    // Check if window is available (SSR safety)
    if (typeof window === 'undefined') return false
    return window.innerWidth < MOBILE_BREAKPOINT
  })

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)

    const onChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches)
    }

    // Set initial value
    setIsMobile(mql.matches)

    // Listen for media query changes (handles window resize)
    mql.addEventListener("change", onChange)

    // Listen for orientation changes (handles device rotation)
    const handleOrientationChange = () => {
      // Small delay to allow viewport to update after orientation change
      setTimeout(() => {
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
      }, 100)
    }

    window.addEventListener("orientationchange", handleOrientationChange)
    window.addEventListener("resize", handleOrientationChange)

    return () => {
      mql.removeEventListener("change", onChange)
      window.removeEventListener("orientationchange", handleOrientationChange)
      window.removeEventListener("resize", handleOrientationChange)
    }
  }, [])

  return isMobile
}
